<div class="modal modal-dialog-centered usr-setting-landing-pop-up" id="userProfile" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content usr-setting-pop-up-field">
        <div class="modal-header">
          <h2 class="modal-title usr-setting-pop-up-header">{{ "CHANGE_ACCESS" | translate }}</h2>
          <button type="button" class="btn-close" (click)="close()">
          </button>
        </div>
        <div class="modal-body usr-setting-pop-up-summary">
          <div>
            <p class="star-definition">Select your desired access level using the toggle, or set any level as your default by marking it with the star icon under 'Levels'.</p>
          </div>
          <!-- loader -->
          <div *ngIf="accessPresent == undefined">
            <div class="loader-container">
              <div class="loader"></div>
            </div>
            <p class="loader-message">{{ loaderMessage }}</p>
          </div>
          <!-- loader end -->
          <div *ngIf="accessPresent != undefined &&  accessPresent == false && managerAccess.length == 0">
            <span><b>{{"ACCOUNT_LEVEL_ACCESS_TEXT" | translate}}</b></span>
          </div>
          <div *ngIf="accessPresent && managerAccess.length">
            <table class="table">
              <thead class="custom-div">
                <tr>
                  <th scope="col"></th>
                  <th scope="col">{{"HIERARCHY_LEVEL" | translate}}</th>
                  <th scope="col">{{"HIERARCHY_VALUES" | translate}}</th>
                  <!-- <th scope="col"></th> -->
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let access of managerAccess; let i = index">
                  <ng-content *ngIf="access.group_key">
                    <td scope="row">
                      <input (click)="setAsDefault(access.group_key, $event, 1)" class="star" type="radio" name="i" [checked]="(access.group_key == toSetDefaultGroupKey) ? true:false ">
                    </td>
                    <td>{{object.mappedHierarchyLevelNames[access.group_key]}}</td>
                    <td>
                      <span>
                        <span *ngFor="let value of access.access_key[access.group_key].values; let value_index = index" [class]="(actionPerform.group_key == access.group_key && actionPerform.index == value_index) ? 'chip activated-chip': 'chip chip-hover'" (click)="switchAccessLevel(access.group_key, $event, value_index, access.access_key, 2)">{{value}}</span>
                      </span>
                    </td>
                  </ng-content>
                  <!-- #todo, Need to handle it for static project -->
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-cancel save-usr-profile-btn" data-dismiss="modal" (click)="close()">
            {{ "CANCEL" | translate }}
          </button>
          <button type="button" class="btn save-usr-profile-btn" [class]="applyDisabled? 'btn-disabled': 'btn-save'" (click)="apply($event)" [disabled]="(applyDisabled || isRequestSubmitted)? true: false">
            {{ "SAVE" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>